"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EnhancedTableHead;
var _react = _interopRequireDefault(require("react"));
var _sortable = require("@dnd-kit/sortable");
var _material = require("@mui/material");
var _density = require("./density");
var _TableHeaderItem = _interopRequireDefault(require("./TableHeaderItem"));
var _Checkbox = require("../Checkbox");
var _text = require("../../utils/text");
function EnhancedTableHead(props) {
  const theme = (0, _material.useTheme)();
  const {
    order,
    orderBy,
    onRequestSort,
    numSelected,
    rowCount,
    onSelectAllClick,
    density = 'comfortable'
  } = props;
  const headerCellStyles = {
    '&.MuiTableCell-root': {
      borderBottom: "2px solid ".concat(theme.palette.TwClrBrdrSecondary)
    },
    paddingTop: '0px',
    paddingBottom: '0px'
  };
  _react.default.useEffect(() => {
    setHeadCells(columnsToHeadCells(props.columns));
  }, [props.columns]);
  function columnsToHeadCells(columns) {
    return columns.map(c => ({
      id: c.key,
      disablePadding: false,
      className: c.className,
      label: typeof c.name === 'string' && c.name.length > 0 ? (0, _text.titleCase)(c.name) : c.name,
      tooltipTitle: c.tooltipTitle,
      alignment: c.alignment,
      sx: [headerCellStyles, ...(Array.isArray(c.sx) ? c.sx : [c.sx])]
    }));
  }
  const [headCells, setHeadCells] = _react.default.useState(columnsToHeadCells(props.columns));
  return /*#__PURE__*/_react.default.createElement(_material.TableHead, null, /*#__PURE__*/_react.default.createElement(_material.TableRow, {
    id: "table-header",
    sx: {
      height: (0, _density.getTableRowHeight)(density)
    }
  }, numSelected !== undefined && rowCount !== undefined && rowCount > 0 && onSelectAllClick && /*#__PURE__*/_react.default.createElement(_material.TableCell, {
    padding: "checkbox",
    sx: headerCellStyles
  }, /*#__PURE__*/_react.default.createElement(_material.Checkbox, {
    disableRipple: true,
    sx: (0, _Checkbox.CheckboxStyle)(theme),
    color: "primary",
    indeterminate: numSelected > 0 && numSelected < rowCount,
    checked: rowCount > 0 && numSelected === rowCount,
    onChange: onSelectAllClick
  })), /*#__PURE__*/_react.default.createElement(_sortable.SortableContext, {
    items: headCells
  }, headCells.map((headCell, i) => {
    return /*#__PURE__*/_react.default.createElement(_TableHeaderItem.default, {
      headCell: headCell,
      order: order,
      orderBy: orderBy,
      onRequestSort: onRequestSort,
      i: i,
      key: i
    });
  }))));
}